import { render, staticRenderFns } from "./ZplPreview.vue?vue&type=template&id=197ac8f2&scoped=true"
import script from "./ZplPreview.vue?vue&type=script&lang=js"
export * from "./ZplPreview.vue?vue&type=script&lang=js"
import style0 from "./ZplPreview.vue?vue&type=style&index=0&id=197ac8f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197ac8f2",
  null
  
)

export default component.exports